<homey-sticky-footer [style.bottom]="aboveTabBar() ? '4rem' : '0'">
  <div class="bg-white py-2 flex justify-center flex-col">
    <homey-submit-button submitButtonLabel="Turn on auto-apply"
                         [submitFunction]="onAutoApplyClick"></homey-submit-button>
    <p-divider class="!my-3" [dt]="whiteDividerDt">or</p-divider>
    <button class="cursor-pointer underline text-muted-color" (click)="onSelectApartmentsClick()">Choose lotteries manually</button>
  </div>
</homey-sticky-footer>
